import { TRAINING_POTION_AID_FILTER_OPTIONS } from "../constants/entrainementSetup";

export const TRAINING_POTION_AID_FILTER_VALUES = TRAINING_POTION_AID_FILTER_OPTIONS.map(
  (option) => option.value
);

function wordHasPotionAid(stats, aid) {
  const last5 = stats?.last5Games;
  if (!Array.isArray(last5) || !last5.length) return false;
  return last5.some((entry) => entry?.potionAid === aid);
}

export function wordMatchesPotionsUsedFilter(word, enabled, filter) {
  if (!enabled) return true;

  const stats = word?.stats;
  if (filter === "memory") return wordHasPotionAid(stats, "M");
  if (filter === "time") return wordHasPotionAid(stats, "T");
  if (filter === "either") {
    return wordHasPotionAid(stats, "M") || wordHasPotionAid(stats, "T");
  }
  if (filter === "both") {
    return wordHasPotionAid(stats, "M") && wordHasPotionAid(stats, "T");
  }

  return false;
}
